module.exports = __webpack_public_path__ + "img/wx.7accbd78.png";